import { forwardRef, type Ref, type SVGProps } from "react";
const IconUndoOutlineSVG = ({
  children,
  ...rest
}: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" viewBox="0 0 32 32" ref={ref} {...rest}>{children}<path fill="currentColor" d="M5 2a1 1 0 0 1 1 1v8.272l6.64-6.636a9 9 0 1 1 12.728 12.728L13.025 29.707a1 1 0 0 1-1.414-1.414L23.954 15.95a7 7 0 0 0-9.9-9.9L7.105 13H16a1 1 0 1 1 0 2H5.5A1.5 1.5 0 0 1 4 13.5V3a1 1 0 0 1 1-1" /></svg>;
const ForwardRef = forwardRef(IconUndoOutlineSVG);
ForwardRef.displayName = "IconUndoOutline";
export { ForwardRef as IconUndoOutline };